@use "Styles/includes/variables";
@use "Styles/mixins";

:host(.vm-client-disclosure--desktop) {
    display: none;
    visibility: hidden;

    @include mixins.min-screen(variables.$xl) {
        display: block;
        visibility: visible;
        margin: 0 0 16px;
    }
}

:host(.vm-client-disclosure--mobile) {
    display: block;
    visibility: visible;
    margin: 0 0 16px;

    @include mixins.min-screen(variables.$xl) {
        display: none;
        visibility: hidden;
    }
}

:host(.is-hidden) {
    display: none !important;
    visibility: hidden !important;
}

:host {
    display: block;

    .vm-client-disclosure {
        &__content-wrap {
            position: relative;
            display: flex;
            align-items: center;
            border: 1px solid mixins.get-color(border, solid, disabled);
            border-radius: 8px;

            &::before {
                content: " ";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                width: 1px;
                height: 100%;
                margin: 0 auto;
                background-color: mixins.get-color(border, solid, disabled);
            }
        }

        &__logo-wrap {
            box-sizing: border-box;
            flex: 0 0 50%;
            padding: 12px 16px;
        }

        &__logo {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            margin: 0 auto;

            img {
                display: block;
                width: 163px;
                height: 39px;
                max-width: 100%;
                object-fit: contain;
            }

            figcaption {
                font-family: variables.$fontQuaternary;
                text-align: center;
                font-size: 12px;
                line-height: 18px;
                color: #717680;
            }

        }

        &__text-wrap {
            box-sizing: border-box;
            padding: 12px 16px;
            flex: 0 0 50%;
            text-align: center;

            p {
                margin: 0;
                font-family: variables.$fontQuaternary;
                font-size: 12px;
                line-height: 18px;
                color: #717680;
            }
        }
    }
}
